var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap" }, [
      _c("img", {
        attrs: {
          src: "https://obs.prod.ubanquan.cn/obs_011602559500001661326898_pre$prod-ubq",
          alt: "",
        },
      }),
      _c("div", [_vm._v("由天河链提供技术支持")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }